// axios 封装：官网只需要"读取展示"，不涉及登录 token
import axios from 'axios'
import { Message } from 'element-ui'

const request = axios.create({
  baseURL: '/api', // 开发环境由 vue.config.js 代理到后端
  timeout: 10000
})

// 响应拦截：统一处理 {code, msg, data} 格式
request.interceptors.response.use(
  response => {
    const data = response.data
    // code 为 0 表示成功；否则弹出后端返回的错误信息
    if (data.code !== 0) {
      Message.error(data.msg || '请求失败')
      return Promise.reject(new Error(data.msg || '请求失败'))
    }
    return data
  },
  error => {
    Message.error('网络异常，请稍后重试')
    return Promise.reject(error)
  }
)

export default request
